import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ComponentModalConfig, ModalSize, SuiModal } from '@richardlt/ng2-semantic-ui';
import { ProfileService } from '../../services/profile.services';

interface IUpdatePasswordModalContext {
  currentValue?: any;
};

@Component({
  selector: 'app-update-password-modal',
  templateUrl: './update-password-modal.component.html',
  styleUrls: ['./update-password-modal.component.scss']
})
export class UpdatePasswordModalComponent implements OnInit {

  passwordUpdateForm!: FormGroup;
  success!: string;
  error!: string;
  pending: boolean;

  constructor(
    public modal: SuiModal<IUpdatePasswordModalContext, void, void>,
    private fb: FormBuilder,
    @Inject(DOCUMENT) private document,
    private profileService: ProfileService
  ) {
    console.log(this.modal.context.currentValue, 'this.modal.context.currentValue')
  }

  ngOnInit(): void {
    this.document.body.classList.add('panel');
    this.passwordUpdateForm = this.fb.group({
      oldPassword: ["", Validators.required],
      newPassword: ["", Validators.required],
      confirmNewPassword: ["", Validators.required]
    });
    
  }

  ngOnDestroy(): void {
		this.document.body.classList.remove('panel');
	}


  save() {
    let body = {
      oldpassword: this.passwordUpdateForm.value.oldPassword,
      password: this.passwordUpdateForm.value.newPassword,

    }
    if (this.passwordUpdateForm.valid && 
      (this.passwordUpdateForm.value.newPassword === this.passwordUpdateForm.value.confirmNewPassword )) {
      this.pending = true;
      console.log(body, 'body');
      this.profileService
        .updatePassword({
          body,
        })
        .subscribe(
          (res) => {
            console.log(res, 'res')
            this.pending = false;
            this.success = 'Password updated successfully';
            setTimeout(() => this.modal.approve(), 500);
          },
          (error) => {
            this.error = error.error ? error.error : error;
            this.pending = false;
          }
        );
    } else {
      this.error = "Make sure that new password matches confirm new password"
    }
  }

  isFieldValid(field: string) {
    return (
      this.passwordUpdateForm.get(field).invalid &&
        this.passwordUpdateForm.get(field).touched
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }

}

export class UpdatePasswordModal extends ComponentModalConfig<IUpdatePasswordModalContext> {
  constructor(currentValue = null, size: ModalSize = ModalSize.Tiny) {
    super(UpdatePasswordModalComponent, {currentValue});
    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  } 
}